export default "__VITE_ASSET__CFv0Gpwr__"